import { Color } from '@vivaldis/ui'
import { FontWeight } from '../../../styles/font'
import { Text, TextProps } from '../../index'

export const BodyAlt = ({
  color = Color.Text.Default,
  fontSize = 16,
  fontWeight = FontWeight.bold,
  letterSpacing = 0.35,
  lineHeight = 22,
  ...props
}: TextProps) => (
  <Text
    color={color}
    fontSize={fontSize}
    fontWeight={fontWeight}
    letterSpacing={letterSpacing}
    lineHeight={lineHeight}
    {...props}
  />
)
